import React, { useState, useEffect } from 'react';
import { Edit3, Save, XCircle } from 'lucide-react';
import AIFormatter from './AIFormatter';

const EditableAIBox = ({ text, isOfficial }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editedText, setEditedText] = useState(text);

  // Dışarıdan yeni bir yapay zeka metni gelirse (Yenile'ye basılırsa) kutuyu güncelle
  useEffect(() => {
    setEditedText(text);
  }, [text]);

  if (!text) return null;

  return (
    <div className="relative group w-full">
      
      {/* SİHİRLİ DÜZENLE BUTONU (Sadece fare üzerine gelince şıkça belirir, yazdırırken gizlenir) */}
      {!isEditing && (
        <div className="absolute -top-3 right-2 no-print z-10 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <button 
            onClick={() => setIsEditing(true)}
            className="flex items-center text-[11px] font-bold text-purple-600 hover:text-white bg-purple-50 hover:bg-purple-600 border border-purple-200 px-3 py-1.5 rounded-lg shadow-sm transition-colors"
          >
            <Edit3 className="h-3 w-3 mr-1.5" /> Düzenle
          </button>
        </div>
      )}

      {/* DÜZENLEME MODU */}
      {isEditing ? (
        <div className="animate-in fade-in duration-300 no-print w-full mt-2">
          <textarea
            value={editedText}
            onChange={(e) => setEditedText(e.target.value)}
            className="w-full min-h-[300px] p-4 text-sm text-slate-700 bg-white border-2 border-purple-300 rounded-xl focus:outline-none focus:border-purple-500 focus:ring-4 focus:ring-purple-100 transition-all custom-scrollbar leading-relaxed"
            placeholder="Yapay zeka analizini düzenleyin veya kendi notlarınızı ekleyin..."
          />
          <div className="flex justify-end gap-2 mt-3">
            <button 
              onClick={() => { setEditedText(text); setIsEditing(false); }}
              className="flex items-center text-xs font-bold text-slate-600 bg-white border border-slate-300 hover:bg-slate-50 px-4 py-2 rounded-lg transition-colors"
            >
              <XCircle className="h-4 w-4 mr-1.5" /> İptal
            </button>
            <button 
              onClick={() => setIsEditing(false)}
              className="flex items-center text-xs font-bold text-white bg-purple-600 hover:bg-purple-700 shadow-md shadow-purple-200 px-4 py-2 rounded-lg transition-colors"
            >
              <Save className="h-4 w-4 mr-1.5" /> Kaydet (PDF'e Yansıt)
            </button>
          </div>
        </div>
      ) : (
        /* GÖRÜNTÜLEME MODU (Normal Renkli Çıktı) */
        <div className="print:text-black">
  <AIFormatter text={editedText} isOfficial={isOfficial} />
</div>
      )}
    </div>
  );
};

export default EditableAIBox;